export default function isEmptyString( testString ) {
	return testString?.trim()?.length === 0;
}
